const Exicutive = [
    {
        name: 'M.A.G. Asif',
        img: ' https://i.ibb.co/dfhcwdg/Asif-Sir.jpg',
        Pos: 'President'
    },
    {
        name: 'MD.Umor Faruk Jahangir',
        img: ' https://i.ibb.co/GT82pnv/Jahangir-Sir.jpg',
        Pos: 'Treasurer'

    },
    {




        name: 'Nahidul Islam Sayel',
        img: ' https://i.ibb.co/PmhnmRt/Nahid.jpg',
        Pos: 'Vice President'

    },
    {
        name: 'MD. Asraf Uzzaman',
        img: 'https://i.ibb.co/NWXJTXL/Asraf.jpg',
        Pos: 'General Secretary',


    },
    {
        name: 'Md. Asraful Goni',
        img: 'https://i.ibb.co/6rq1JnX/Gaming.png',
        Pos: 'Assistant General Secretary',


    }
]
export default Exicutive;